import { useEffect, useState } from 'react';

type FnProp = () => void;
export default function useInterval(
    f: FnProp,
    delay = 1000,
    autoStart = true,
): { start: FnProp; stop: FnProp; busy: boolean } {
    const [busy, setBusy] = useState<boolean>(autoStart);

    useEffect(() => {
        // start
        if (!busy) return;
        setBusy(true);
        const t = setInterval(f, delay);
        // stop
        return () => {
            setBusy(false);
            clearInterval(t);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [busy, delay]);

    return {
        start: () => setBusy(true), // start
        stop: () => setBusy(false), // stop
        busy,
    };
}
